import ReactDOM from "react-dom/client";
import { QueryClientProvider, QueryClient } from "react-query";
import { Provider } from "react-redux";
import appstore from "./Store";
import ReactApp from "./App";
import React from "react";
import { AuthProvider } from "react-oidc-context";
import CognitoAuthConfig, { _GET_AUTH_CONFIG } from "./models/common/cognitoAuthConfig";

const container = document.getElementById("root");
const root = ReactDOM.createRoot(container as HTMLElement);

let cognitoAuthConfig= _GET_AUTH_CONFIG(window?.location?.hostname);
// const cognitoAuthConfig = {
//   authority: "https://cognito-idp.ap-south-1.amazonaws.com/ap-south-1_uHDVCj9ky",
//   client_id: "4741ohv03oceamafslppvvag7u",
//   redirect_uri: "http://localhost:3000",
//   response_type: "code",
//   scope: "email openid phone",
// };
root.render(
  <AuthProvider {...cognitoAuthConfig}>
    <Provider store={appstore}>
      <QueryClientProvider
        client={
          new QueryClient({
            defaultOptions: {
              queries: {
                refetchOnWindowFocus: true,
              },
            },
          })
        }
      >
        <ReactApp />
      </QueryClientProvider>
    </Provider>
  </AuthProvider>
);
